import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {Code, Heading, Spacer, Spacing} from '/component/base/Storybook';

import CabBanner from '../CabBanner';

storiesOf('partial', module).add('CabBanner', () => (
  <ScrollView>
    <Spacing size={20}>
      <Heading level={1}>Client Acquisition Bonus Banner</Heading>
      <Spacer size={16} />
      <Text>
        The <Code>CabBanner</Code> component is used to show data related to
        CabBanner.
      </Text>
      <Spacer size={16} />
      <CabBanner
        // @ts-expect-error TS(2769): No overload matches this call.
        showCABBanner={true}
        cabBannerFqv={500}
        orderingEntities={1}
        daysLeftForCAB={17}
      />
      <Spacer size={16} />
      <Text>
        To correctly render the component you don't need to pass any props:
      </Text>
      <Spacer size={6} />
      <Code>{'<CabBanner />'}</Code>
      <Spacer size={16} />
    </Spacing>
  </ScrollView>
));
